import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceResponse } from "@common/data-models/service/service-response";
import { IAuthService } from '@common/interfaces/i-auth.service';
import { AppService } from '@suite/app.service';
import { LogonService } from '@common/services/logon-service';

import { AuthConfig } from 'angular-oauth2-oidc';
import { OAuthService } from 'angular-oauth2-oidc';
import { NomWebServicesJson } from '../../nom-web-services-json';

declare var localDirectory;


export const oktaAuthConfig: AuthConfig = {
    issuer: '',
    tokenEndpoint: '',
    redirectUri: window.location.origin + '/' + localDirectory + '/',
    clientId: '',
    scope: 'openid email',
    strictDiscoveryDocumentValidation: false,
    loginUrl: '',
    requestAccessToken: false,
    responseType: "id_token"
}

export const microsoftAuthConfig: AuthConfig = {
    issuer: 'https://graph.microsoft.com/v1.0/me',
    tokenEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
    redirectUri: window.location.origin + '/' + localDirectory + '/',
    clientId: '',
    scope: 'User.Read email profile',
    strictDiscoveryDocumentValidation: false,
    loginUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    requestAccessToken: true,
    responseType: "id_token"
}

export const googleAuthConfig: AuthConfig = {
    issuer: 'https://accounts.google.com',
    redirectUri: window.location.origin + '/' + localDirectory + '/',
    clientId: '',
    scope: 'openid profile email',
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    sessionChecksEnabled: true
}

@Injectable({ providedIn: 'root' })
export class SSOService implements IAuthService {

    public providerName: string = null;

    constructor(public appService: AppService,
        private logonService: LogonService,
        private oauthService: OAuthService,
        private router: Router,
        private nomWebServicesJson: NomWebServicesJson
    ) { }

    public async authenticate(): Promise<ServiceResponse<void>> {
        this.navigateToAuth();
        return new ServiceResponse<void>(true);
    }

    public async loginWithToken(): Promise<ServiceResponse<void>> {
        let token = localStorage.getItem("idToken");
        let providerName = (localStorage.getItem("providerName") ? localStorage.getItem("providerName") : '');
        return await this.logonService.logonSSO(providerName, token);
    }

    public logout() {
        localStorage.removeItem("providerName");
        localStorage.removeItem("idToken");

        if (window["ANDROID_WRAPPER"]) window["ANDROID_WRAPPER"].logout();
        this.nomWebServicesJson.clearSessionData();
        this.router.navigate(['/login']);
    }

    public async navigateToAuth() {
        let authAppUri = this.appService.ssoConfigSettings["AuthAppUrl"];
        if (window['ANDROID_WRAPPER']?.setAuthAppUrl) window['ANDROID_WRAPPER'].setAuthAppUrl(authAppUri);
        let provider = this.providerName.split(" ")[0]; //handling Microsoft Azure and Microsoft Live
        window.location.href = authAppUri + "/#/?providerName=" + provider + "&redirectUri=" + window.location.href //have to get dynamically from g_config
    }
}
